import { styled } from '@/stitches.config';

import { Box, IconButton, SectionTitle } from '@base-app';
import { ReactComponent as Exit } from '@assets/icons/exit.svg';

export const StyledContainerModal = styled(Box, {
  backgroundColor: 'rgba(0,0,0,0.4)',
  display: 'flex',
  height: '100vh',
  overflow: 'auto',
  overflowY: 'auto',
  position: 'fixed',
  top: '$0',
  width: '100%',
  zIndex: '$modal',
});

export const StyledModal = styled(Box, {
  backgroundColor: 'white',
  borderRadius: '$3',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  margin: 'auto',
  width: '100%',
  '@sm': {
    margin: 'auto',
    height: 'auto',
  },

  variants: {
    size: {
      small: {
        '@sm': {
          maxWidth: '500px',
          width: '60%',
        },
        '@md': {
          width: '40%',
        },
      },
      medium: {
        '@sm': {
          maxWidth: '600px',
          width: '70%',
        },
        '@md': {
          width: '50%',
        },
      },
      large: {
        '@sm': {
          maxWidth: '700px',
          width: '80%',
        },
        '@md': {
          width: '60%',
        },
      },
      extra_large: {
        '@sm': {
          maxWidth: '800px',
          width: '90%',
        },
        '@md': {
          width: '70%',
        },
      },
      xx_large: {
        height: '80%',
        '@sm': {
          maxWidth: '900px',
          width: '95%',
        },
        '@md': {
          width: '80%',
        },
      },
      xxx_large: {
        '@sm': {
          maxWidth: '1000px',
          width: '99%',
        },
        '@md': {
          width: '90%',
        },
      },
      xxxx_large: {
        '@sm': {
          maxWidth: '1200px',
          width: '99%',
        },
        '@md': {
          width: '90%',
        },
      },
    },
  },
});

export const StyledHeader = styled(Box, {
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'space-between',
  padding: '$0 $6',
  position: 'relative',
  width: '100%',
});

export const StyledFooter = styled(Box, {
  alignContent: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: '$5',
});

const regularTitle = {
  textAlign: 'center',
};

const largerTitle = {
  color: '$darkBlue200',
  textAlign: 'left',
};

export const StyledTitle = styled(SectionTitle, {
  flexGrow: '1',
  fontWeight: '$bold',
  fontSize: '$xxl',
  variants: {
    size: {
      small: {
        ...regularTitle,
      },
      medium: {
        ...regularTitle,
      },
      large: {
        ...regularTitle,
      },
      extra_large: {
        ...regularTitle,
      },
      xx_large: {
        ...largerTitle,
      },
      xxx_large: {
        ...largerTitle,
      },
      xxxx_large: {
        ...largerTitle,
      },
    },
  },
});

export const StyledContent = styled(Box, {
  borderTop: '1px solid $coolGray200',
  flexGrow: '1',
  overflow: 'auto',
  padding: '$6',
});

export const StyledIconButton = styled(IconButton, {
  height: '$8',
  position: 'absolute',
  right: '$4',
  width: '$8',
});

export const StyledExitIcon = styled(Exit, {});
